import { handleBffError } from './error';

export const bffFetch = async <T>(query: object, headers: object = {}) => {
  const path = `${window.location.origin}/${import.meta.env.VITE_APP_BFF_PATH}`;

  try {
    const response = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(query),
    });

    const body = await response.json();

    if (!body.data && body.errors && Array.isArray(body.errors) && body.errors.length > 0) {
      throw body.errors[0];
    }

    return body.data as T;
  } catch (err) {
    handleBffError(err);
  }
};
